//import '../stickyplayer/global.css';

//@todo inject player script and css on demand

(function() {
    
    if(window.pw.debug) return;

FWDMSPUtils.onReady(function(){

    const mainFolderPath = (window.pw.templates || '/site/templates/') + 'assets/fwd/';

    new FWDMSP({
        //main settings
        instanceName:"player1",
        playlistsId:"playlists",
        mainFolderPath: mainFolderPath,
        skinPath:"minimal_skin_dark",
        //privatePassword:"428c841430ea18a70f7b06525d4b748a",
        //soundCloudAPIKey:"0aff03b3b79c2ac02fd2283b300735bd",
        //showSoundCloudUserNameInTitle:"yes",
        //googleAnalyticsTrackingCode:"UA-122352201-1",
        showMainBackground:"yes",
        verticalPosition:"bottom",
        horizontalPosition:"center",
        useDeepLinking:"no",
        useYoutube:"yes",
        useVideo:"yes",
        useContinuousPlayback:'no',
        useHEXColorsForSkin:"no",
        normalHEXButtonsColor:"#FF0000",
        selectedHEXButtonsColor:"#00FF00",
        rightClickContextMenu:"default",
        showButtonsToolTips:"yes",
        animate:"yes",
        addKeyboardSupport:"yes",
        autoPlay:"no",
        loop:"no",
        shuffle:"no",
        maxWidth:800,
        volume:.8,
        toolTipsButtonsHideDelay:1.5,
        toolTipsButtonFontColor:"#888888",
        //controller settings
        showControllerByDefault:"yes",
        showThumbnail:"yes",
        showFullScreenButton:"yes",
        showNextAndPrevButtons:"yes",
        showSoundAnimation:"yes",
        showLoopButton:"no",
        showShuffleButton:"no",
        showDownloadMp3Button:"yes",
        showBuyButton:"yes",
        showShareButton:"no",
        showMainScrubberAndVolumeScrubberToolTipLabel:"yes",
        expandBackground:"no",
        titleColor:"#FFFFFF",
        timeColor:"#888888",
        scrubbersToolTipLabelBackgroundColor:"#FFFFFF",
        scrubbersToolTipLabelFontColor:"#5a5a5a",
        //controller align and size settings (described in detail in the documentation!)
        controllerHeight:76,
        startSpaceBetweenButtons:9,
        spaceBetweenButtons:8,
        separatorOffsetOutSpace:5,
        separatorOffsetInSpace:9,
        lastButtonsOffsetTop:14,
        allButtonsOffsetTopAndBottom:14,
        titleBarOffsetTop:13,
        mainScrubberOffsetTop:47,
        spaceBetweenMainScrubberAndTime:10,
        startTimeSpace:10,
        scrubbersOffsetWidth:2,
        scrubbersOffestTotalWidth:0,
        volumeButtonAndScrubberOffsetTop:47,
        spaceBetweenVolumeButtonAndScrubber:6,
        volumeScrubberOffestWidth:4,
        scrubberOffsetBottom:10,
        equlizerOffsetLeft:1,
        //playlists window settings
        showPlaylistsSearchInput:"no",
        usePlaylistsSelectBox:"yes",
        showPlaylistsSelectBoxNumbers:"yes",
        showPlaylistsButtonAndPlaylists:"yes",
        showPlaylistsByDefault:"no",
        thumbnailSelectedType:"opacity",
        startAtPlaylist:0,
        startAtTrack:0,
        startAtRandomTrack:"no",
        buttonsMargins:0,
        thumbnailMaxWidth:330, 
        thumbnailMaxHeight:330,
        horizontalSpaceBetweenThumbnails:40,
        verticalSpaceBetweenThumbnails:40,
        mainSelectorBackgroundSelectedColor:"#FFFFFF",
        mainSelectorTextNormalColor:"#FFFFFF",
        mainSelectorTextSelectedColor:"#000000",
        mainButtonTextNormalColor:"#888888",
        mainButtonTextSelectedColor:"#FFFFFF",
        //playlist settings
        playTrackAfterPlaylistLoad:"no",
        showPlayListButtonAndPlaylist:"yes",
        showPlayListOnAndroid:"no",
        showPlayListByDefault:"no",
        showPlaylistItemPlayButton:"yes",
        showPlaylistItemDownloadButton:"yes",
        showPlaylistItemBuyButton:"yes",
        forceDisableDownloadButtonForPodcast:"yes",
        forceDisableDownloadButtonForOfficialFM:"yes",
        forceDisableDownloadButtonForFolder:"yes",
        addScrollBarMouseWheelSupport:"yes",
        showTracksNumbers:"yes",
        disableScrubber:"no",
        randomizePlaylist:"no",
        playlistBackgroundColor:"#000000",
        trackTitleNormalColor:"#888888",
        trackTitleSelectedColor:"#FFFFFF",
        trackDurationColor:"#888888",
        maxPlaylistItems:100,
        nrOfVisiblePlaylistItems:12,
        trackTitleOffsetLeft:0,
        playPauseButtonOffsetLeftAndRight:11,
        durationOffsetRight:9,
        downloadButtonOffsetRight:11,
        scrollbarOffestWidth:7,
        //playback rate / speed
        showPlaybackRateButton:"no",
        defaultPlaybackRate:1, //min - 0.5 / max - 3
        playbackRateWindowTextColor:"#FFFFFF",
        //login
        isLoggedIn:"yes",
        playTrackOnlyWhenLoggedIn:"yes",
        loggedInMessage:"Please login to play this track.",
        //search bar settings
        showSearchBar:"no",
        showSortButtons:"yes",
        searchInputColor:"#999999",
        searchBarHeight:38,
        inputSearchTextOffsetTop:1,
        inputSearchOffsetLeft:0,
        //password window
        borderColor:"#333333",
        mainLabelsColor:"#FFFFFF",
        secondaryLabelsColor:"#a1a1a1",
        textColor:"#5a5a5a",
        inputBackgroundColor:"#000000",
        inputColor:"#FFFFFF",
        //opener settings
        openerAlignment:"right",
        showOpener:"yes",
        showOpenerPlayPauseButton:"yes",
        openerEqulizerOffsetLeft:3,
        openerEqulizerOffsetTop:-1,
        //popup settings
        showPopupButton:"no",
        popupWindowBackgroundColor:"#878787",
        popupWindowWidth:850,
        popupWindowHeight:423,
        //a to b loop
        atbTimeTextColorNormal:"#888888",
        atbTimeTextColorSelected:"#FFFFFF",
        atbButtonTextNormalColor:"#888888",
        atbButtonTextSelectedColor:"#FFFFFF",
        atbButtonBackgroundNormalColor:"#FFFFFF",
        atbButtonBackgroundSelectedColor:"#000000"
    });

    /*window.player1.addListener(FWDMSP.READY, () => {
        window.setTimeout(() => {
            if(window.matchMedia('only screen and (max-width: 719px)').matches) {
            //    window.player1.hidePlayer();
            }
        }, 3000)
    });*/
    
});

})();